import React from 'react';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import {ListItem, makeStyles} from '@material-ui/core';
import {Fonts} from '../../../shared/constants/AppEnums';
import {CremaTheme} from '../../../types/AppContextPropsType';

interface NotificationItemProps {
  message: string;
  timestamp: string;
  listStyle: string;
}

const NotificationListItem: React.FC<NotificationItemProps> = ({
  message,
  timestamp,
  listStyle,
}) => {
  const useStyles = makeStyles((theme: CremaTheme) => ({
    textBase: {
      fontSize: 16,
      [theme.breakpoints.up('xl')]: {
        fontSize: 18,
      },
    },
    minWidth0: {
      minWidth: 0,
    },
  }));

  const classes = useStyles();
  return (
    <ListItem className={listStyle}>
      <Box component='p' className={classes.textBase} color='grey.500'>
        <Box
          mr={2}
          component='span'
          display='inline-block'
          color='text.primary'
          fontFamily={Fonts.LIGHT}>
          {message}
        </Box>
        {timestamp}
      </Box>
    </ListItem>
  );
};

export default NotificationListItem;

NotificationListItem.propTypes = {
  message: PropTypes.string.isRequired,
  timestamp: PropTypes.string.isRequired,
};
